import React from "react";
import styles from "./.FilterBoxComponents.module.css";
import emailFilterStyles from "./ContactEmailFilter.module.css";
import {capitalize} from "functions/fields";
const PhoneFilter = ({ 
  phoneTypes, setPhoneTypes,
}) => {

  // EMAIL VALIDATION OPTIONS
  const phoneTypesOptionsList = ["mobile","company"];
  const handlePhoneOptionsChange = (event) => {
    const { value, checked } = event.target;
    setPhoneTypes((prevValues) =>
      checked
        ? prevValues.includes(value)
          ? prevValues
          : [...prevValues, value]
        : prevValues.filter((item) => item !== value)
    );
  };

  // const capitalizeFirstLetter = (string) => {
  //   return string.charAt(0).toUpperCase() + string.slice(1);
  // }


  return (
    <div className={styles.accordionContent}>
      {/* PHONE TYPES */}
        <label>Contact has:</label>
        <div className={emailFilterStyles.emailCheckboxContainer}>
          {phoneTypesOptionsList.map((option) => (
            <label>
              <div className={emailFilterStyles.checkBoxRow}>
                <input
                  type="checkbox"
                  value={option}
                  checked={phoneTypes.includes(option)}
                  onChange={handlePhoneOptionsChange}
                  className={emailFilterStyles.emailCheckbox}
                />
                <div>{capitalize(option)} Phone</div>
              </div>
            </label>
          ))}
      </div>
    </div>
  );
};

export default PhoneFilter;
